import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit, ViewChild
} from "@angular/core";
import { HROUTES } from '../horizontal-menu/navigation-routes.config';
import { ROUTES } from './vertical-menu-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { customAnimations } from "../animations/custom-animations";
import { AuthDataService } from "../auth/auth-data.service";
import { AuthService } from "../auth/auth.service";
import { ConfigService } from '../services/config.service';
import { LayoutService } from '../services/layout.service';
import { LoadingOverlayService } from "../services/loading-overlay.service";
import { RouteInfo } from "./vertical-menu.metadata";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  styleUrl: "./vertical-menu.component.scss",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = 'assets/img/rf_old/rfplayer_transparent.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;

  rotasAutenticadas: RouteInfo[];
  rotas: RouteInfo[];
  @ViewChild('toggleButtonthirdlevel') toggleButtonthirdlevel!: ElementRef;


  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private authDataService: AuthDataService,
    private authService: AuthService,
    private loaderService: LoadingOverlayService,
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    this.loaderService.show();
    this.rotas = JSON.parse(JSON.stringify(ROUTES));
    if (this.authDataService.isAuthenticated()) {
      if (this.authDataService.isRoutingAuthenticated()) {
        const rotas = this.authService.obterRotasAutenticadas([...this.rotas], this.authDataService.rotasAutenticadas);
        this.rotasAutenticadas = [...rotas];

        this.loadLayout();
        this.cdr.markForCheck();
      } else {
        this.authService.obterTodasRotasAutenticadasUsuario([...this.rotas]).subscribe(res => {
          this.authDataService.adicionarDadosRota(res);

          const rotas = this.authService.obterRotasAutenticadas([...this.rotas], this.authDataService.rotasAutenticadas);
          this.rotasAutenticadas = [...rotas];

          this.loadLayout();
          this.cdr.markForCheck();
        })
      }
    }
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });
  }

  sincronizarListasDeRotas(lista1: RouteInfo[], lista2: RouteInfo[]) {
    lista1.forEach(rota1 => {
      const rotaCorrespondente = lista2.find(rota2 => rota2.path === rota1.path && rota2.title === rota1.title);

      if (!rotaCorrespondente) {
        lista2.push({ ...rota1 });
      } else if (rota1.submenu && rota1.submenu.length > 0) {
        this.sincronizarListasDeRotas(rota1.submenu, rotaCorrespondente.submenu);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    this.loaderService.hide();

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      this.menuItems = this.rotasAutenticadas;
    }

    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = this.logoUrl;
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    //TODO deprecated
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
